var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.contentBlock && _vm.contentBlock.paragraphs)?_c('div',{staticClass:"vuw-rich-text"},_vm._l((_vm.contentBlock.paragraphs),function(paragraph,index){return _c('atom-paragraph',{key:index,attrs:{"paragraph":paragraph}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }